import { formaterDate, formaterMontant } from '../lib/format';
import { libelleTitreTransport } from '../lib/contrat';
import type { TypeTitreTransport } from '../types';
import { Infobulle } from './Infobulle';

/**
 * Mutuelle et transport en icônes, à côté du nom du salarié dans la liste
 * des contrats (2026-10-02). Elles remplacent deux tags de texte qui
 * alourdissaient la ligne. Même recette que l'icône de civilité : SVG
 * maison en 16 px, gris, et le sens survit dans l'infobulle et dans
 * `aria-label` — une icône seule ne se lit pas au lecteur d'écran.
 */

const CLASSE = 'h-4 w-4 shrink-0 text-encre-500';

/** Une croix dans un cercle : le signe de la santé. */
export function IconeMutuelle({ depuis }: { depuis: string | null }) {
  const libelle = depuis ? `Mutuelle souscrite depuis le ${formaterDate(depuis)}` : 'Mutuelle souscrite';
  return (
    <Infobulle texte={libelle} className="inline-flex">
      <svg viewBox="0 0 16 16" className={CLASSE} role="img" aria-label={libelle}>
        <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 4.5v7M4.5 8h7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </Infobulle>
  );
}

/**
 * Un bus : le titre de transport, bus comme métro. L'infobulle ne dit que
 * le titre et son prix : la part remboursée dépend du temps de travail du
 * mois (2026-11-04), elle se lit dans la paie.
 */
export function IconeTransport({ montant, type }: { montant: number; type?: TypeTitreTransport | null }) {
  const libelle = `${libelleTitreTransport(type)} ${formaterMontant(montant)}/mois`;
  return (
    <Infobulle texte={libelle} className="inline-flex">
      <svg viewBox="0 0 16 16" className={CLASSE} role="img" aria-label={libelle}>
        <rect x="2.5" y="1.8" width="11" height="10.4" rx="2" fill="currentColor" />
        <rect x="4" y="3.6" width="8" height="4" rx="0.6" fill="#fff" />
        <circle cx="5.2" cy="10" r="0.9" fill="#fff" />
        <circle cx="10.8" cy="10" r="0.9" fill="#fff" />
        <rect x="3.6" y="12.2" width="2.4" height="2.2" rx="0.6" fill="currentColor" />
        <rect x="10" y="12.2" width="2.4" height="2.2" rx="0.6" fill="currentColor" />
      </svg>
    </Infobulle>
  );
}
